import { FC } from 'react';

import { ArrowLeftOutline, ArrowRightOutline, Box, Button, CheckOutline, HStack } from '@bonusly/design-system';

interface SpotlightNavigationProps {
	currentIndex: number;
	totalCards: number;
	onPrevious: () => void;
	onNext: () => void;
	onGoToCard: (index: number) => void;
}

export const SpotlightNavigation: FC<SpotlightNavigationProps> = ({ currentIndex, totalCards, onPrevious, onNext, onGoToCard }) => {
	const isFirst = currentIndex === 0;
	const isLast = currentIndex === totalCards - 1;

	return (
		<Box position="relative" width="100%" maxW="900px" mx="auto" mt={8} display="flex" justifyContent="space-between" alignItems="center" zIndex={50}>
			<Button
				leftIcon={<ArrowLeftOutline size="sm" />}
				variant="ghost"
				onClick={onPrevious}
				disabled={isFirst}
				px="20px"
				py="10px"
				color="text.soft"
				_hover={{
					bg: 'none',
				}}
				_active={{
					bg: 'none',
				}}
			>
				Back
			</Button>

			<HStack spacing={2}>
				{Array.from({ length: totalCards }).map((_, index) => (
					<Box
						key={index}
						as="button"
						w={index === currentIndex ? '40px' : '14px'}
						h="14px"
						borderRadius="20px"
						border={index === currentIndex ? 'none' : '1px solid'}
						borderColor="text.onColor"
						bg={index === currentIndex ? 'bg.surface' : 'bg.topNav'}
						backdropFilter={index === currentIndex ? 'none' : 'blur(2px)'}
						boxShadow={
							index === currentIndex
								? '0 19px 6px 0 rgba(0, 0, 0, 0.01), 0 11px 5px 0 rgba(0, 0, 0, 0.02), 0 5px 4px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 0 1px 0 rgba(0, 0, 0, 0.08)'
								: 'none'
						}
						cursor="pointer"
						transition="all 0.2s ease"
						onClick={() => onGoToCard(index)}
						_hover={{
							bg: index === currentIndex ? 'bg.surface' : 'bg.surface',
						}}
					/>
				))}
			</HStack>

			<Button
				rightIcon={isLast ? <CheckOutline size="sm" /> : <ArrowRightOutline size="sm" />}
				variant="solid"
				onClick={onNext}
				disabled={isLast}
				bg="secondary.bg"
				color="text.onColor"
				px="20px"
				py="10px"
				h="auto"
				fontSize="sm"
				_hover={{
					bg: 'secondary.bgHover',
					color: 'text.onColor',
				}}
				_active={{
					bg: 'secondary.bgActive',
					color: 'text.onColor',
				}}
			>
				{isLast ? 'Create a Post' : 'Next'}
			</Button>
		</Box>
	);
};
